// import axios from 'axios'
// import store from '@/store'
// import router from '@/router'

// const service = axios.create({
//   baseURL: window.apiurl,
//   // baseURL: 'https://mock.presstime.cn/mock/6750268c7b6a5d20ea0b0d06/xinfang',
//   timeout: 10000
// })

// // 添加请求拦截器，若token存在则在请求头中加token，不存在也继续请求
// service.interceptors.request.use(
//   config => {
//     // 每次发送请求之前都检测vuex是否存有token,放在请求头发送给服务器
//     // Authorization是根据后端自定义字段
//     config.headers.Authorization = store.getters.getToken || ''

//     // 添加 Content-Type: application/json
//     config.headers['Content-Type'] = 'application/json'

//     return config
//   }, error => {
//     console.log('在request拦截器显示错误：', error.response)
//     return Promise.reject(error)
//   }
// )

// // respone 响应拦截器
// // service.interceptors.response.use(
// //   response => {
// //     // 在status正确的情况下，code不正确则返回对应的错误信息（后台自定义为200是正确，并且将错误信息写在message），正确则返回响应
// //     return response.data.code === 200 ? response : Promise.reject(response.data.message)
// //   },
// //   error => {
// //     // 在status不正确的情况下，判别status状态码给出对应响应
// //     if (error.response) {
// //       console.log('在respone拦截器显示错误：', error.response)
// //       switch (error.response.status) {
// //         case 401:
// //           // 可能是token过期，清除它
// //           store.commit('delToken')

// //           router.replace({ // 跳转到登录页面
// //             path: '/login',
// //             // 将跳转的路由path作为参数，登录成功后跳转到该路由
// //             query: { redirect: router.currentRoute.fullPath }
// //           })
// //       }
// //     }
// //     return Promise.reject(error.response.data)
// //   }
// // )
// // 响应拦截器
// service.interceptors.response.use(
//   response => {
//     // 可以根据需要处理返回的数据
//     if (response.data && response.data.code !== 200) {
//       // 如果响应中的 code 不等于 200，抛出错误
//       return Promise.reject(new Error(response.data.message || '请求失败'))
//     }
//     return response.data // 直接返回响应的数据部分
//   },
//   error => {
//     // 响应错误处理
//     console.error('响应错误:', error)
//     if (error.response) {
//       // 根据不同的状态码做相应的处理
//       switch (error.response.status) {
//         case 401:
//           // 处理未授权，比如跳转到登录页
//           router.replace({ // 跳转到登录页面
//             path: '/login',
//             // 将跳转的路由path作为参数，登录成功后跳转到该路由
//             query: { redirect: router.currentRoute.fullPath }
//           })
//           break
//         case 500:
//           // 服务器错误
//           alert('服务器错误，请稍后再试！')
//           break
//         default:
//           break
//       }
//     }
//     return Promise.reject(error) // 返回错误
//   }
// )

// export default service

import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { Notification, MessageBox, Message, Loading } from 'element-ui'
import { TENANT_ID } from '@/utlis/tenant'
// 多租户：全局租户标识（值见 @/utlis/tenant），同时覆盖 service 实例与各页面的裸 axios 调用
axios.defaults.headers.common['X-Tenant-Id'] = TENANT_ID
const service = axios.create({
  baseURL: window.apiurl,
  // baseURL: window.apiurl,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})
export let isRelogin = { show: false };
// 添加请求拦截器，若token存在则在请求头中加token，不存在也继续请求
service.interceptors.request.use(
  config => {
    const token = store.getters.getToken
    if (token) {
      config.headers.Authorization = token
    }
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    console.error('在request拦截器显示错误：', error.response)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  res => {
    var errorCode = {
  '401': '认证失败，无法访问系统资源',
  '403': '当前操作没有权限',
  '404': '访问资源不存在',
  'default': '系统未知错误，请反馈给管理员'
}
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode['default']
    // 二进制数据则直接返回
    if (res.request.responseType ===  'blob' || res.request.responseType ===  'arraybuffer') {
      return res.data
    }
    if (code === 401) {
      alert('会话已过期，请重新登录')
    store.commit('delToken')
    window.location.href = '/'
      return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    } else if (code === 500) {
      Message({ message: msg, type: 'error' })
      return Promise.reject(new Error(msg))
    } else if (code === 601) {
      Message({ message: msg, type: 'warning' })
      return Promise.reject('error')
    } else if (code !== 200) {
      Notification.error({ title: msg })
      return Promise.reject('error')
    } else {
      return res.data
    }
  },
  error => {
    console.error('响应错误:', error)
    if (error.response) {
      switch (error.response.status) {
        case 401:
          router.replace({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }
          })
          break
        case 500:
          alert('服务器错误，请稍后再试！')
          break
        case 403:
          alert('无权限访问该资源')
          break
        case 404:
          alert('请求的资源未找到')
          break
        case 408:
          alert('请求超时')
          break
        default:
          alert(error.response.data.message || '请求失败')
          break
      }
    } else if (error.code === 'ECONNABORTED') {
      alert('请求超时，请稍后重试')
    }

    // return Promise.reject(error.response?.data?.message || '请求发生错误')
  }
)

export default service
